export const formatAmount = (num: number | null | undefined): string =>
  (num || 0).toFixed(2);
